import React, { useMemo, Fragment, useState, useEffect } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Grid, IconButton, Chip } from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import * as C from "components";
import * as H from "helper";
import TimeLineIcon from "@material-ui/icons/Timeline";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { setCurrentPage, getA2ECampaignsPicTree } from "actions";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: "flex",
      position: "fixed",
      backgroundColor: "#fafafa",
      zIndex: 1000,
      width: "100%",
    },
    alignLeft: {
      lineHeight: "18px",
      textAlign: "left",
    },
    summaryCenter: {
      textAlign: "center",
    },
    cvrHead: {
      textAlign: "center",
      fontSize: 12,
      fontWeight: "normal",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
    },
    flexItemLeftBox: {
      marginTop: 28,
      alignSelf: "center",
      paddingLeft: 8,
      paddingRight: 8,
      borderRight: "1px solid #dcdcdc",
    },
  })
);

const PicTreeQuizList = ({
  setCurrentPage,
  tableRowSelected,
  campaigns,
  getA2ECampaignsPicTree,
}) => {
  const classes = useStyles();
  const [filteredRowCount, setFilteredRowCount] = useState(campaigns.length);

  useEffect(() => {
    setCurrentPage(window.location.pathname);
    getA2ECampaignsPicTree();
  }, []);

  const getReportUrl = (cid) => {
    let url = "/a2e/report/" + cid;
    return url;
  };

  const getCampaignData = (data) => {
    if (data.length > 0) {
      let allDataArray = [],
        eachDataArray = [];
      for (let i = 0; i < data.length; i++) {
        eachDataArray.push(data[i]["status"]);
        eachDataArray.push(data[i]["clientName"]);
        eachDataArray.push(data[i]["name"]);
        eachDataArray.push(data[i]["materialName"]);
        eachDataArray.push(data[i]["quizId"]);
        eachDataArray.push(data[i]["quizTxt"]);
        eachDataArray.push(data[i]["correctRate"]);
        eachDataArray.push(data[i]["imp"]);
        eachDataArray.push(data[i]["startWatchCount"]);
        eachDataArray.push(data[i]["completeWatchCount"]);
        eachDataArray.push(data[i]["answerCount"]);
        eachDataArray.push(data[i]["correctCount"]);
        eachDataArray.push(data[i]["clickHintCount"]);
        eachDataArray.push(data[i]["clickBannerCount"]);
        eachDataArray.push(data[i]["uniqueAnswerCount"]);
        eachDataArray.push(data[i]["mediaConversionCount"]);
        eachDataArray.push(data[i]["purchaseCount"]);
        eachDataArray.push(data[i]["startDate"]);
        eachDataArray.push(data[i]["endDate"]);
        eachDataArray.push(data[i]["duration"]);
        eachDataArray.push(data[i]["remainDays"]);
        // eachDataArray.push(data[i]["campaignId"]);
        allDataArray.push(eachDataArray);
        eachDataArray = [];
      }
      return allDataArray;
    }
  };

  const getColumns = () => {
    let returningColumn = columns;
    if (
      localStorage.getItem("access_key") !== process.env.REACT_APP_SUPERUSER
    ) {
      returningColumn.pop();
    }
    return returningColumn;
  };

  const options = {
    filterType: "dropdown",
    filter: true,
    pagination: true,
    search: true,
    print: false,
    download: true,
    downloadOptions: {
      filename: "クイズ回答別集計.csv",
      filterOptions: {
        useDisplayedRowsOnly: true,
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      const cleanData = data.map((row, index) => ({
        index,
        data: row.data,
      }));
      return "\uFEFF" + buildHead(columns) + buildBody(cleanData);
    },
    selectableRows: "none",
    rowsPerPage: 20,
    rowsSelected: tableRowSelected,
    textLabels: {
      body: {
        noMatch: "データを取得中です。",
        toolTip: "",
      },
      toolbar: {
        search: "検索",
        viewColumns: "列の表示",
        downloadCsv: "CSVダウンロード",
        filterTable: "テーブルのフィルター",
      },
      viewColumns: {
        title: "表示する列",
        titleAria: "テーブルの列の表示/非表示",
      },
      pagination: {
        next: "次のページ",
        previous: "前のページ",
        rowsPerPage: "表示件数",
      },
      filter: {
        all: "全て",
        title: "フィルター",
        reset: "リセット",
      },
      selectedRows: {
        text: "レコードを選択",
        delete: "削除",
        deleteAria: "選択したレコードを削除する",
      },
    },
    rowsPerPageOptions: [10, 20, 50, 100],
    onTableChange: (action, tableState) => {
      if (action === "propsUpdate" || action === "filterChange" || action === "search") {
        setFilteredRowCount(tableState.displayData.length);
      }
    },
  };

  let columns = [
    {
      name: "状況",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Chip
              size="small"
              label={value}
              style={{
                backgroundColor:
                  value.indexOf("Active") !== -1 ? "#aeeab2" : "#f4a915",
              }}
            />
          );
        },
      },
    },
    {
      name: "広告主",
      options: {
        filter: true,
        // customFilterListRender: (v) => `広告主: ${v}`,
        customBodyRender: (value) => {
          return <div className={classes.alignLeft}>{value}</div>;
        },
        customValue: (value, tableMeta, updateValue) => value,
      },
    },
    {
      name: "クイズ名",
      options: {
        filter: true,
        // customFilterListRender: (v) => `クイズ名: ${v}`,
        customBodyRender: (value) => {
          return <div className={classes.alignLeft}>{value}</div>;
        },
        customValue: (value, tableMeta, updateValue) => value,
      },
    },
    {
      name: "素材名",
      options: {
        filter: true,
        // customFilterListRender: (v) => `素材名: ${v}`,
        customBodyRender: (value) => {
          return <div lassName={classes.alignLeft}>{value}</div>;
        },
        customValue: (value, tableMeta, updateValue) => value,
      },
    },
    {
      name: "クイズID",
      options: {
        filter: false,
        // customFilterListRender: (v) => `クイズID: ${v}`,
        customBodyRender: (value) => {
          return <div>{value}</div>;
        },
        customValue: (value, tableMeta, updateValue) => value,
      },
    },
    {
      name: "問題文",
      options: {
        filter: false,
        customBodyRender: (value) => {
          return <div>{value}</div>;
        },
        customValue: (value, tableMeta, updateValue) => value,
      },
    },
    {
      name: "正答率",
      options: {
        filter: false,
        customBodyRender: (value) => {
          return <div>{value}</div>;
        },
        customValue: (value, tableMeta, updateValue) => value,
      },
    },
    {
      name: "インプレッション",
      options: {
        filter: false,
        customBodyRender: (value) => {
          return <div>{value}</div>;
        },
        customValue: (value, tableMeta, updateValue) => value,
      },
    },
    {
      name: "視聴数",
      options: {
        filter: false,
        customBodyRender: (value) => {
          return <div>{value}</div>;
        },
        customValue: (value, tableMeta, updateValue) => value,
      },
    },
    {
      name: "試聴完了数",
      options: {
        filter: false,
        customBodyRender: (value) => {
          return <div>{value}</div>;
        },
        customValue: (value, tableMeta, updateValue) => value,
      },
    },
    {
      name: "回答数",
      options: {
        filter: false,
        // customFilterListRender: (v) => `回答数: ${v}`,
        customBodyRender: (value) => {
          return <div>{value}</div>;
        },
        customValue: (value, tableMeta, updateValue) => value,
      },
    },
    {
      name: "正解数",
      options: {
        filter: false,
        // customFilterListRender: (v) => `名前: ${v}`,
        customBodyRender: (value) => {
          return <div>{value}</div>;
        },
        customValue: (value, tableMeta, updateValue) => value,
      },
    },
    {
      name: "ヒントクリック数",
      options: {
        filter: false,
        customBodyRender: (value) => {
          return <div>{value}</div>;
        },
        customValue: (value, tableMeta, updateValue) => value,
      },
    },
    {
      name: "バナークリック数",
      options: {
        filter: false,
        customBodyRender: (value) => {
          return <div>{value}</div>;
        },
        customValue: (value, tableMeta, updateValue) => value,
      },
    },
    {
      name: "ユニーク回答数",
      options: {
        filter: false,
        // customFilterListRender: (v) => `名前: ${v}`,
        customBodyRender: (value) => {
          return <div>{value}</div>;
        },
        customValue: (value, tableMeta, updateValue) => value,
      },
    },
    {
      name: "メディアCV数",
      options: {
        filter: false,
        // customFilterListRender: (v) => `名前: ${v}`,
        customBodyRender: (value) => {
          return <div>{value}</div>;
        },
        customValue: (value, tableMeta, updateValue) => value,
      },
    },
    {
      name: "購入CV数",
      options: {
        filter: false,
        // customFilterListRender: (v) => `名前: ${v}`,
        customBodyRender: (value) => {
          return <div>{value}</div>;
        },
        customValue: (value, tableMeta, updateValue) => value,
      },
    },
    {
      name: "開始日",
      options: {
        filter: false,
        // customFilterListRender: (v) => `名前: ${v}`,
        customBodyRender: (value) => {
          return <div>{value}</div>;
        },
        customValue: (value, tableMeta, updateValue) => value,
      },
    },
    {
      name: "終了日",
      options: {
        filter: false,
        // customFilterListRender: (v) => `名前: ${v}`,
        customBodyRender: (value) => {
          return <div>{value}</div>;
        },
        customValue: (value, tableMeta, updateValue) => value,
      },
    },
    {
      name: "全日数",
      options: {
        filter: false,
        // customFilterListRender: (v) => `名前: ${v}`,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <div>{value}日</div>;
        },
        customValue: (value, tableMeta, updateValue) => value,
      },
    },
    {
      name: "残り日数",
      options: {
        filter: false,
        // customFilterListRender: (v) => `名前: ${v}`,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <div>{value}日</div>;
        },
        customValue: (value, tableMeta, updateValue) => value,
      },
    },
    // {
    //   name: "レポート",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return (
    //         <Link
    //           to={getReportUrl(tableMeta.rowData[tableMeta.rowData.length - 1])}
    //           target="_blank"
    //         >
    //           <IconButton aria-label="詳細">
    //             <TimeLineIcon fontSize="small" />
    //           </IconButton>
    //         </Link>
    //       );
    //     },
    //   },
    // },
  ];

  return (
    <Fragment>
      <C.ContentWrapper>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <MUIDataTable
              title={`クイズ：${filteredRowCount}件`}
              data={getCampaignData(campaigns)}
              columns={getColumns()}
              options={options}
            />
          </Grid>
        </Grid>
      </C.ContentWrapper>
    </Fragment>
  );
};

PicTreeQuizList.propTypes = {
  classes: PropTypes.object,
  campaigns: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

const mapStateToProps = (state) => ({
  tableRowSelected: state.page.tableRowSelected,
  campaigns: state.a2e.campaignsPicTree,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  getA2ECampaignsPicTree: () => dispatch(getA2ECampaignsPicTree()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PicTreeQuizList);
